import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import { useRouter } from 'next/router'
import classnames from 'classnames'

import Container from 'components/Layout/Container'
import { MaterialIcon } from 'controls'
import styles from './styles'

function Breadcrumbs({ breadcrumbs }) {
  return (
    <nav aria-label="breadcrumbs">
      <ul className="breadcrumb">
        {breadcrumbs.map(({ breadcrumb, href, ...rest }, index) => {
          return (
            <li className="breadcrumb-item" key={index}>
              <Link href={href} {...rest}>
                <a
                  className={classnames('breadcrumb-name', {
                    deactivated: index === breadcrumbs.length - 1
                  })}
                >
                  {breadcrumb}
                </a>
              </Link>
              {index < breadcrumbs.length - 1 && (
                <MaterialIcon
                  icon="navigate_next"
                  size="small"
                  style={{
                    marginLeft: '0.5rem',
                    marginBottom: '-0.1rem',
                  }}
                />
              )}
            </li>
          )
        })}
      </ul>
      <style jsx>{styles}</style>
    </nav>
  )
}

function BreadCrumb({ breadcrumbSections }) {
  const { asPath, ...restRouter } = useRouter()
  const [breadcrumbs, setBreadcrumbs] = useState(null)

  useEffect(
    () => {
      if (asPath) {
        const linkPath = asPath.split('/')
        linkPath.shift() // First element is an empty string

        const pathArray = linkPath
          .map((path, i) => {
            const breadcrumbResolve =
              breadcrumbSections.length > 0 ? breadcrumbSections[i] : path

            if (typeof breadcrumbResolve === 'function') {
              return breadcrumbResolve({
                asPath,
                breadcrumbPath: path,
                ...restRouter
              })
            }

            return {
              breadcrumb: breadcrumbResolve,
              href: '/' + linkPath.slice(0, i + 1).join('/')
            }
          })
          .filter(Boolean)
        setBreadcrumbs(pathArray)
      }
    },
    [asPath]
  )

  if (!breadcrumbs) {
    return null
  }

  return <Container><Breadcrumbs breadcrumbs={breadcrumbs} /></Container>
}

BreadCrumb.propTypes = {
  url: PropTypes.string.isRequired,
  breadcrumbSections: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.func])
  )
}

export default BreadCrumb
